import * as React from 'react';

import {
  LocalVirtualGraphOptionsContext,
  useLocalVirtualGraphOptionsValue,
} from 'src/containers/ProjectVirtualGraphPreviewDialog/hooks/useLocalVirtualGraphOptionsValue';
import {
  LocalVirtualGraphContext,
  useLocalVirtualGraphValue,
} from 'src/containers/ProjectVirtualGraphPreviewDialog/hooks/useLocalVirtualGraphValue';
import { useRefreshVgTables } from 'src/containers/ProjectVirtualGraphPreviewDialog/hooks/useRefreshVgTables';
import { ProjectVirtualGraph } from 'src/store/state/projects';

type ProjectVirtualGraphPreviewDialogContextProviderProps = {
  children: React.ReactNode;
  virtualGraph: ProjectVirtualGraph;
};

export const ProjectVirtualGraphPreviewDialogContextProvider: React.VFC<
  ProjectVirtualGraphPreviewDialogContextProviderProps
> = ({ children, virtualGraph }) => {
  const localVirtualGraphValue = useLocalVirtualGraphValue(virtualGraph);
  const localVirtualGraphOptionsValue = useLocalVirtualGraphOptionsValue(
    virtualGraph.options
  );

  useRefreshVgTables(localVirtualGraphValue[0]);

  return (
    <LocalVirtualGraphContext.Provider value={localVirtualGraphValue}>
      <LocalVirtualGraphOptionsContext.Provider
        value={localVirtualGraphOptionsValue}
      >
        {children}
      </LocalVirtualGraphOptionsContext.Provider>
    </LocalVirtualGraphContext.Provider>
  );
};
